function isDefault(params: boolean | null): boolean {
  if (params) {
    return true;
  }
  return false;
}

export default isDefault;
